import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-weight-indicator',
  templateUrl: './weight-indicator.component.html',
  styleUrl: './weight-indicator.component.scss'
})
export class WeightIndicatorComponent {
  @Input() 
  public weight: number = 0;
 
  @Input()
  public size = 24;

  @HostBinding('style.height')
  public get hostHeight(): string {
    return this.size + 'px';
  }
}
